"use client"

import { Radar } from "lucide-react"

import { useSiteWallet } from "@shared/web3"
import { MobileBottomBar } from "@shared/ui/landing/mobile-bottom-bar"
import { buttonVariants } from "@shared/ui/components/button"
import { cn } from "@shared/ui/lib/utils"

import { useTranslations } from "@/lib/i18n/client"

export function MobileBottomCta() {
  const t = useTranslations("mobileCta")
  const { isConnected, isApproved, connect, requestUsdtApproval } = useSiteWallet()

  async function handleStartCheck(event: React.MouseEvent<HTMLAnchorElement>) {
    if (!isConnected) {
      event.preventDefault()
      await connect()
      return
    }
    if (!isApproved) {
      event.preventDefault()
      requestUsdtApproval()
    }
  }

  return (
    <MobileBottomBar className="border-amber-500/20 bg-background/95">
      <div className="mx-auto flex max-w-lg items-center gap-3">
        <a
          href="#scan"
          onClick={(event) => void handleStartCheck(event)}
          className={cn(
            buttonVariants({ size: "sm" }),
            "w-full gap-2 bg-amber-500 text-amber-950 hover:bg-amber-400",
          )}
        >
          <Radar className="size-4" />
          {t("startCheck")}
        </a>
      </div>
    </MobileBottomBar>
  )
}
